
import axios from 'axios';
import cookies from 'vue-cookies';
import $screen from 'vue-screen';
import router from '@/router/index';

import Helper from '@/lib/langTemplates/HelperClauses';

const baseUrl = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/';

const Bundle = {

  actions: {

    async getBundle(context){
      context.dispatch('loadingOn');
      try {
        let raw = (await axios.get(baseUrl + 'bundle', {headers: {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        }})).data;
        context.commit('setOrg', raw.org);
        context.commit('setUser', raw.user);
        context.commit('setBuildings', raw.buildings);
        context.commit('setTeam', raw.team);
        context.commit('setAlerts', {alerts: raw.alerts, overall: raw.overallAlerts});
        let header = {
          title: context.rootState.org.name,
          lgText: context.rootState.buildings.length,
          smText: `Building${context.rootState.buildings.length === 1 ? '' : 's'}<br/> Monitored`,
          alerts: context.rootState.overallAlerts,
          type: 'org'
        }
        context.commit('setHeader', header);
        router.push({path: '/organization'});
        if (!raw.buildings || !raw.buildings.length){
          context.dispatch('initNotif', {
            type: 'tutorial',
            title: `Tutorials Enabled`,
            body: `Welcome to BreeziPro! Since this is the first time you have logged in, Tutorial Mode has been enabled. This will give you hoverable hints, tips and supplementary information
              to help you kickstart your BreeziPro experience! If at any time you would like to DISABLE Tutorial Mode, just click the green icon at the top-right of the page. Click
              the "Add Building" button to set up your first property.`
          });
          if (!context.rootState.user.tutorial) context.dispatch('toggleTutorial');
        }
        context.dispatch('loadingOff');
      } catch(err) {
        console.log(err);
        router.push({path: '/'});
        context.dispatch('loadingOff');
        // TODO: Set notif for fail to load initial bundle
      }
    },

    async togUnits(context, pressure){
      const params = {
        method: 'POST',
        url: `${baseUrl}units${pressure ? '?pressure=true' : '?pressure=false'}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        }
      }
      try {
        await axios(params);
        context.commit('updateUnits', pressure);
      } catch(err) {
        console.log(err);
      }
    },

    async refreshRoom(context, did){
      const url = `${baseUrl}bundle/device/${did.toString()}`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: cookies.get('breeziProTkn')
      }
      try {
        const room = (await axios.get(url, {headers: headers})).data;
        context.commit('insertAsyncRoom', room);
        return Promise.resolve(room);
      } catch(err) {
        console.log({REFRESH_ERROR: err});
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.refFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.refFail[context.rootState.lang]
        })
      }
    },

    async changeFilter(context, vId){
      const url = baseUrl + 'changeFilter';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: cookies.get('breeziProTkn')
      };
      try {
        const body = JSON.stringify({airVentId: vId, buildingId: context.rootState.buildingId});
        await axios.post(url, body, {headers: headers});
        context.commit('updateAfterChangeFilter', vId);
        context.dispatch('initNotif', {
          type: 'notif',
          title: Helper.clauses.filterChanged[`${context.rootState.lang}Title`],
          body: Helper.clauses.filterChanged[context.rootState.lang]
        });
        return Math.round(Date.now()/1000);
      } catch(err) {
        console.log({CHANGE_FILTER_ERROR: err});
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.changeFilterFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.changeFilterFail[context.rootState.lang]
        })
        return 0;
      }
    },

    async destroyBldg(context){
      // const toDel = context.rootState.activeBuilding.id;
      const bldg = context.rootState.buildings.find(b => b.id === context.rootState.buildingId);
      const url = `${baseUrl}buildings/${context.rootState.buildingId}`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: cookies.get('breeziProTkn')
      };
      context.dispatch('loadingOn');
      try {
        await axios.delete(url, {headers: headers});
        context.commit('removeBldgFromState');
        context.dispatch('initNotif', {
          type: 'notif',
          title: Helper.clauses.bldgDel[`${context.rootState.lang}Title`],
          body: Helper.clauses.bldgDel[context.rootState.lang].replace(/{ }/g, bldg.info.name)
        });
        context.dispatch('loadingOff');
      } catch(err) {
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.bldgDelFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.bldgDelFail[context.rootState.lang].replace(/{ }/g, bldg.info.name)
        });
        context.dispatch('loadingOff');
      }
    },

    async deleteRoom(context, did){
      const bldg = context.rootState.buildings.find(b => b.id === context.rootState.buildingId);
      const floor = bldg.floors.find(f => f.info.index == parseInt(context.rootState.floorIndex));
      const room = floor.rooms.find(r => r.did === did.did);
      const url = `${baseUrl}rooms/${did.did}`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: cookies.get('breeziProTkn')
      }
      try {
        await axios.delete(url, {headers: headers});
        context.commit('deleteRoomFromState', did);
        context.dispatch('initNotif', {
          type: 'notif',
          title: Helper.clauses.roomDel[`${context.rootState.lang}Title`],
          body: Helper.clauses.roomDel[context.rootState.lang].replace(/{ }/g, room.info.hvacName)
        });
        // context.dispatch('updateDeleteRoom', did);
      } catch(err) {
        console.log({ERROR: err});
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.roomDelFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.roomDelFail[context.rootState.lang].replace(/{ }/g, room.info.hvacName)
        });
      }
    }

  }

}

export default Bundle;



// WEBPACK FOOTER //
// ./src/store/bundle.js